import { render, staticRenderFns } from "./marketTable.vue?vue&type=template&id=88a1aa28&scoped=true&"
import script from "./marketTable.vue?vue&type=script&lang=js&"
export * from "./marketTable.vue?vue&type=script&lang=js&"
import style0 from "./marketTable.vue?vue&type=style&index=0&id=88a1aa28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a1aa28",
  null
  
)

export default component.exports